/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_DescriptionInputs */

const en_settings_tickets_description = /** @type {(inputs: Settings_Tickets_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a ticket and our team will get back to you`)
};

/**
* | output |
* | --- |
* | "Submit a ticket and our team will get back to you" |
*
* @param {Settings_Tickets_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_tickets_description = /** @type {((inputs?: Settings_Tickets_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_tickets_description(inputs)
});
export { settings_tickets_description as "settings.tickets.description" }